import React from 'react';
import PropTypes from 'prop-types';
import { Route, withRouter } from 'react-router-dom';

/**
 * Route Handler that renders given component if isAuthorized true or redirects
 * @function AuthorizedRoute
 * @param {Object} props
 * @return {ReactElement}
 */
const AuthorizedRoute = (props) => {
  const {
    component: Component,
    exact = false,
    isAuthorized = false,
    path,
  } = props;

  return isAuthorized
    ? <Route exact={exact} path={path}><Component {...props} /></Route>
    : null;
};

AuthorizedRoute.propTypes = {
  component: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.func,
    PropTypes.symbol,
    PropTypes.node,
  ]).isRequired,

  exact: PropTypes.bool,
  isAuthorized: PropTypes.bool,
  path: PropTypes.string.isRequired,
};

export default withRouter(AuthorizedRoute);
export { AuthorizedRoute as PureAuthorizedRoute };
